<div style="text-align:center;padding-top:10px" *ngIf="healthVisitLog.length == 0  && isBusy==false" translate>No Health Visit Log data exists for student</div>
<div *ngIf="healthVisitLog.length > 0 ">
  <mat-table matSort matSortDisableClear matSortActive="Date" matSortDirection="desc" [dataSource]="angularMatData" aria-label="Health Visit Log Data Table">
    <ng-container matColumnDef="Date">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;max-width:150px"><span translate>Date</span>
          <filter class="mat-filter" [data]="angularMatData" columnName="Date" dataType="date"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let hvl" style="min-width:150px;max-width:150px">
        <span *ngIf="hvl.Date != '0001-01-01T00:00:00'">{{hvl.Date|date:'MM/dd/yy'}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="TimeIn">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;max-width:150px; display:flex;justify-content:center;"><span translate>Time In</span>
          <filter class="mat-filter" [data]="angularMatData" columnName="TimeIn" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let hvl" style="min-width:150px;max-width:150px; display:flex; justify-content:center; padding-right:15px;">{{hvl.TimeIn}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="TimeOut">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:180px;max-width:180px; display:flex;justify-content:center;"><span translate>Time Out</span>
          <filter class="mat-filter" [data]="angularMatData" columnName="TimeOut" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let hvl" style="min-width:180px;max-width:180px; display:flex;justify-content:center; padding-right:15px;">{{hvl.TimeOut}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="VisitReason">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:250px;max-width:250px"><span translate>Visit Reason</span>
          <filter class="mat-filter" [data]="angularMatData" columnName="VisitReason" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let hvl" style="min-width:250px;max-width:250px;">{{hvl.VisitReason}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="Action">
      <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Action</span>
          <filter class="mat-filter" [data]="angularMatData" columnName="Action" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let hvl">{{hvl.Action}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="SentTo">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left: 10px;"><span translate>Sent To</span>
          <filter class="mat-filter" [data]="angularMatData" columnName="SentTo" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let hvl" style="padding-left: 10px;">{{hvl.SentTo}}</mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedHealthColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedHealthColumns;" [attr.aria-label]="getHealthVisitLogAriaRow(row)"></mat-row>
  </mat-table>
</div>
